import { Collection, Entity, ManyToOne, OneToMany, PrimaryKey, Property } from '@mikro-orm/core';
import { User } from '../../user/entities/user.entity';
import { Newsfeed } from '../../newsfeed/entities/newsfeed.entity';

@Entity({ tableName: 'chapters' })
export class Chapter {
  @PrimaryKey({ autoincrement: true })
  id!: number;

  @ManyToOne(() => User)
  user!: User;

  @Property()
  title!: string;

  @OneToMany(() => Newsfeed, (n) => n.chapter)
  newsfeeds = new Collection<Newsfeed>(this);

  @Property()
  created_at: Date = new Date();

  @Property({ onUpdate: () => new Date() })
  updated_at: Date = new Date();

  @Property({ nullable: true })
  deleted_at?: Date;
}
